export default __webpack_public_path__ + "static/media/layers.7c94c004.gif";